import classNames from 'classnames';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { useAccount } from '@/hooks/useAccount';
import { webCampaign } from '@/modules/webCampaign';
import { AI_DATA } from '@/pages/Onboarding/constants';

import { PaywallAppStepsStyles } from './AppStep.styles';
import {
  HOW_IT_WORKS,
  HOW_IT_WORKS_LURE_AI,
  HOW_IT_WORKS_OPEN_APP,
  HOW_IT_WORKS_WEB,
} from './constants';

export const PaywallAppSteps: React.FC<{
  stepGetPlanBgUrl?: string;
  stepExploreBgUrl?: string;
  stepDiveInBgUrl?: string;
}> = ({ stepGetPlanBgUrl, stepExploreBgUrl, stepDiveInBgUrl }) => {
  const { user } = useAccount();
  const isDominationTheme = webCampaign.getStaticTheme() === 'domination';
  const isWebVersion = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.WEB_VERSION,
  );
  const isHowItWorksOpenApp = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.HOW_IT_WORKS_OPEN_APP,
  );

  const getStepsData = () => {
    if (webCampaign.isPaywallLure()) return HOW_IT_WORKS_LURE_AI;
    if (isWebVersion) return HOW_IT_WORKS_WEB;
    if (isHowItWorksOpenApp) return HOW_IT_WORKS_OPEN_APP;
    return HOW_IT_WORKS;
  };

  const getLureAIStepGetPlanBgUrl = () => {
    const gender = user?.onboarding_data?.gender;
    if (gender === 'male') {
      return `${S3_BUCKET_URL}/paywall/lure-app/app-in-phone-male.png`;
    }
    return `${S3_BUCKET_URL}/paywall/lure-app/app-in-phone-female.png`;
  };

  const stepsData = getStepsData();

  const getStepGetPlanBgUrl = () => {
    if (stepGetPlanBgUrl) return stepGetPlanBgUrl;
    if (webCampaign.isPaywallLure()) return getLureAIStepGetPlanBgUrl();
    return AI_DATA[webCampaign.aiType].paywallHowItWorks.stepOne.bgImageSrc;
  };

  return (
    <PaywallAppStepsStyles
      stepGetPlanBgUrl={getStepGetPlanBgUrl()}
      stepExploreBgUrl={
        stepExploreBgUrl || AI_DATA[webCampaign.aiType].circleIcons
      }
      stepDiveInBgUrl={
        stepDiveInBgUrl ||
        AI_DATA[webCampaign.aiType].paywallHowItWorks.stepThree.bgImageSrc
      }
      staticTheme={webCampaign.getStaticTheme()}
    >
      {stepsData.map((item) => (
        <div
          key={item.title}
          className={classNames('paywall-app-steps-card', webCampaign.aiType)}
        >
          <UiTypography
            variant="label-medium"
            className="paywall-app-steps-card-step"
            color={isDominationTheme ? 'white' : undefined}
          >
            Step {item.step}
          </UiTypography>
          <UiTypography
            variant="title-small"
            className="paywall-app-steps-card-label"
          >
            {item.title}
          </UiTypography>
          <UiTypography color="neutral-black" variant="body-small">
            {item.description}
          </UiTypography>
        </div>
      ))}
    </PaywallAppStepsStyles>
  );
};
